<div>
    <div class="modal-header">
      <h4> {{title}} </h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" [innerHTML]="message"></div>
<div class="modal-footer justify-content-end" *ngIf='showBtn'>
  <div class="button-row">
    <button class="btn primary_btn ok-btn" (click)="close()">{{footerBtnTxt}}</button>
  </div>
</div>
</div>